import { t } from 'i18next';
import { DialogOptions } from '@/components/@IntranetLibrary/Dialog';

const ATTACH_FAILED_DIALOG_PREFIX = 'record-attach-failed-';

const attachFailedDialogId = (uuid: string) =>
  `${ATTACH_FAILED_DIALOG_PREFIX}${uuid}`;

/** 연결 실패 안내창인지 — 어떤 녹음의 안내든 떠 있는지 다른 화면에서 확인할 때 쓴다 */
export const isAttachFailedDialogId = (id?: string) =>
  !!id?.startsWith(ATTACH_FAILED_DIALOG_PREFIX);

/**
 * 녹음 · 음성 파일을 문서에 연결하지 못했을 때의 안내 (PORTAL-12588).
 *
 * 파일 전송은 끝났고 연결만 실패한 상태라, 「다시 시도」는 업로드 없이 연결만 다시 한다.
 * 버튼으로만 결정하게 한다 — 배경 클릭 · ESC · X 로 닫으면 결정이 없는 채로 남아,
 * 녹음 상태가 남아 다음에 여는 문서에 연결을 시도하던 문제가 있었다(QA HIGH).
 * 안내는 파일마다 하나만 띄운다 — 연속 실패 시 같은 안내가 겹쳐 쌓였다.
 */
export const attachFailedDialogOptions = ({
  uuid,
  onRetry,
  onGiveUp,
}: {
  uuid: string;
  onRetry: () => void;
  onGiveUp: () => void;
}): DialogOptions => ({
  id: attachFailedDialogId(uuid),
  cancelButtonText: t('취소'),
  confirmButtonText: t('다시 시도'),
  message: t(
    '녹음을 문서에 추가하지 못했어요.\n다시 시도하면 업로드 없이 바로 추가돼요.',
  ),
  onConfirm: onRetry,
  onCancel: onGiveUp,
  isBlockBackDropClose: true,
  isBlockEscapeClose: true,
  showCloseButton: false,
});

/** 「취소」 뒤 안내 — 연결하지 않은 파일은 화면에서 다시 찾을 수 없다 */
export const ATTACH_GIVEN_UP_MESSAGE =
  '녹음이 문서에 추가되지 않았어요.\n필요하면 다시 녹음하거나 파일을 다시 올려 주세요.';
